import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import Table from "../../../_common/Table";
import EquipmentDetails from "./EquipmentDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditEquipmentModal from "./EditEquipmentModal";
import EquipmentUploadModal from "./EquipmentUploadModal";
import AlertModal from "../../../_common/AlertModal";
import equipmentActions from "../../../../_actions/equipmentActions";
import { getProjContractorOptions } from "../../../../_helpers/contractorOptions";
import { docPermConstants } from "../../../../_constants/permissionConstants";
import contractorActions from "../../../../_actions/contractorActions";

class EquipmentList extends Component {
  state = {
    contractorFilter: null,
    equipFilter: "",
    selectedEquipmentId: 0,
    sortColumn: { path: "makeDesc", order: "asc" },
    showEditEquipModal: false,
    showUploadModal: false,
    isNew: false,
    showAlert_deleteEquipment: false,
  };

  columns = [
    { path: "number", label: "No.", thClassName: "" },
    { path: "makeDesc", label: "Make, Model/Desc.", thClassName: "" },
    {
      path: "contractorName",
      label: "Contractor",
      content: (equip) => this.getContractorName(equip.contractorId),
      thClassName: "",
    },
  ];

  componentDidMount() {
    const { projectId, dispatch } = this.props;
    dispatch(equipmentActions.getAll(projectId));
    dispatch(contractorActions.getAllForProject(projectId));
  }

  getContractorName = (ctrId) => {
    const { projContractorList } = this.props;
    const ctr = (projContractorList || []).find((c) => c.contractorId === ctrId);
    if (ctr) return ctr.name;
    return "(N/A)";
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });
  handleChange_contractorFilter = (contractorFilter) =>
    this.setState({ contractorFilter });
  handleChange_equipFilter = (e) => this.setState({ equipFilter: e.target.value });

  getData = () => {
    const { projEquipList } = this.props;
    const { contractorFilter, equipFilter, sortColumn } = this.state;

    const filteredByContractor =
      contractorFilter !== null
        ? (projEquipList || []).filter((e) => e.contractorId === contractorFilter.value)
        : projEquipList || [];
    const filteredByEquip =
      equipFilter !== ""
        ? filteredByContractor.filter((e) =>
            e.numberMakeDesc.toLowerCase().includes(equipFilter.trim().toLowerCase())
          )
        : filteredByContractor;
    return _.orderBy(filteredByEquip, [sortColumn.path], [sortColumn.order]);
  };

  handleClick_equipTr = (selectedEquipment) => {
    const { dispatch, projectId } = this.props;
    selectedEquipment.projectId = projectId;
    this.setState({ selectedEquipmentId: selectedEquipment.equipmentId }, () =>
      dispatch(equipmentActions.getDetails(selectedEquipment.equipmentId, projectId))
    );
  };

  toggleEditEquipModal = () =>
    this.setState({ showEditEquipModal: !this.state.showEditEquipModal });

  toggleUploadModal = () =>
    this.setState({ showUploadModal: !this.state.showUploadModal });

  toggleAlert_deleteEquipment = () =>
    this.setState({
      showAlert_deleteEquipment: !this.state.showAlert_deleteEquipment,
    });

  handleAlert_deleteEquipment = (alertAction) => (e) => {
    e.preventDefault();
    if (alertAction === "accept") this.deleteEquipment();
    this.toggleAlert_deleteEquipment();
  };

  editEquipment = () => {
    this.setState({ isNew: false });
    this.toggleEditEquipModal();
  };

  deleteEquipment = () => {
    const { dispatch, projectId } = this.props;
    const { selectedEquipmentId } = this.state;
    this.setState({ selectedEquipmentId: 0 }, () =>
      dispatch(equipmentActions.deleteEquipment(selectedEquipmentId, projectId))
    );
  };

  renderTableFilters = () => {
    const { equipFilter, contractorFilter } = this.state;
    const { permissions, projContractorList, projectId, dispatch, user } = this.props;
    const canUploadCsv = user?.isOfficeAdmin || user?.isSystemAdmin;
    return (
      <div className="d-flex flex-row flex-wrap pa-filter-group w-100 mb-1">
        <div className="pa-filter-item pa-filter-item__input flex-grow-1">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="equipFilter"
              id="equipFilter"
              className="form-control mr-2"
              value={equipFilter}
              onChange={this.handleChange_equipFilter}
              placeholder="No/Make/Model/Desc."
            />
          </div>
        </div>
        <div className="pa-filter-item pa-filter-item__select pa-filter-item__select--contractor mr-2">
          <Select
            name="contractorFilter"
            id="contractorFilter"
            value={contractorFilter}
            options={projContractorList && getProjContractorOptions(projContractorList)}
            onChange={this.handleChange_contractorFilter}
            isSearchable={false}
            isClearable
            placeholder="Contractor"
          />
        </div>
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="addNewEquip"
            id="addNewEquip"
            className="btn btn-info px-2 mr-2"
            onClick={() =>
              this.setState({
                isNew: true,
                selectedEquipmentId: 0,
                showEditEquipModal: true,
              })
            }
            disabled={!permissions.includes(docPermConstants.EDIT)}
          >
            <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
            Add...
          </button>
        </div>
        {canUploadCsv && (
          <div className="pa-filter-item pa-filter-item__btn">
            <button
              type="button"
              name="uploadCsv"
              id="uploadCsv"
              className="btn btn-info mr-2"
              onClick={this.toggleUploadModal}
            >
              <FontAwesomeIcon icon="upload" className="fa-fw mr-2" />
              Upload CSV
            </button>
          </div>
        )}
        <div className="pa-filter-item pa-filter-item__btn">
          <button
            type="button"
            name="downloadCsv"
            id="downloadCsv"
            className="btn btn-secondary"
            onClick={() => dispatch(equipmentActions.downloadAll(projectId))}
          >
            <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
            CSV
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedEquipmentId,
      sortColumn,
      showEditEquipModal,
      showUploadModal,
      isNew,
      showAlert_deleteEquipment,
    } = this.state;
    const { projectId } = this.props;
    const data = this.getData();
    return (
      <React.Fragment>
        <div className="d-flex flex-row p-2 w-100">
          <div className="pa-list">
            {this.renderTableFilters()}
            <div className="pa-list__table--wrapper border">
              <Table
                className="table table-hover table-sm pa-list__table"
                data={data}
                idPropName="equipmentId"
                selectedItemId={selectedEquipmentId && selectedEquipmentId}
                columns={this.columns}
                sortColumn={sortColumn}
                onSort={this.handleSort}
                handleClick_tr={this.handleClick_equipTr}
              />
            </div>
          </div>
          <div className="pa-details">
            <div className="card w-100 sticky-top top-margin-30">
              <div className="card-header">Equipment Details</div>
              <div className="card-body p-3">
                <EquipmentDetails
                  projectId={projectId}
                  equipmentId={selectedEquipmentId}
                  editEquipment={this.editEquipment}
                  toggleAlert_deleteEquipment={this.toggleAlert_deleteEquipment}
                />
              </div>
            </div>
          </div>
        </div>
        {showEditEquipModal && (
          <EditEquipmentModal
            projectId={projectId}
            equipmentId={selectedEquipmentId}
            showEditEquipModal={showEditEquipModal}
            toggleEditEquipModal={this.toggleEditEquipModal}
            isNew={isNew}
          />
        )}
        {showUploadModal && (
          <EquipmentUploadModal
            projectId={projectId}
            showUploadModal={showUploadModal}
            toggleUploadModal={this.toggleUploadModal}
          />
        )}
        {showAlert_deleteEquipment && (
          <AlertModal
            alertTitle="Delete Equipment"
            alertTitleClass="bg-danger text-white"
            alertText={`Are you sure you want to delete the following equipment?\n${
              data.find((e) => e.equipmentId === selectedEquipmentId).numberMakeDesc
            }`}
            alertTitleIcon="exclamation-triangle"
            acceptCaption="Yes"
            acceptClass="danger"
            provideReject={true}
            rejectCaption="No"
            rejectClass="secondary"
            toggleAlertModal={this.toggleDeleteEquipAlert}
            handleAlertAction={this.handleAlert_deleteEquipment}
            showAlertModal={showAlert_deleteEquipment}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projEquipList: state.equipment.projEquipLists[ownProps.projectId] || null,
  projContractorList: state.contractors.projContractorLists[ownProps.projectId] || null,
  user: state.authentication.user,
});

export default connect(mapStateToProps)(EquipmentList);
